import { Product } from '../../types';
import { CSVOptions, CSVRow } from '../../types/csv';
import { CSV_HEADERS } from './headers';
import { formatProductRow, resetImageCounter } from './formatters';

function escapeField(field: string | number | undefined | null): string {
  if (field === undefined || field === null) return '';
  const stringField = String(field);
  // Double up quotes if field contains quotes, commas, or newlines
  if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
    return `"${stringField.replace(/"/g, '""')}"`;
  }
  return stringField;
}

export function generateCSV(products: Product[], options: CSVOptions = {}, useDescriptionTemplate: boolean = true): string {
  const { includeHeaders = true } = options;
  const rows: string[] = [];

  // Reset image counter before processing products
  resetImageCounter();

  // Add headers
  if (includeHeaders) {
    const headerRow = CSV_HEADERS.map(header => header.label).join(',');
    rows.push(headerRow);
  }

  // Add data rows
  products.forEach(product => {
    const formattedRow = formatProductRow(product, useDescriptionTemplate);
    const escapedRow = formattedRow.map(field => escapeField(field));
    rows.push(escapedRow.join(','));
  });

  return rows.join('\r\n');
}